export const SeguroCosechaArray =[
    {id:'S',display:'SI'},
    {id:'N',display:'NO'},
    {id:'C',display:'COMPAÑIA'}
]